module.exports = __webpack_public_path__ + "img/reportforrepair3.420b0635.png";